(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentRequestDialogController', AgentRequestDialogController);

    AgentRequestDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentRequest', 'Company'];

    function AgentRequestDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentRequest, Company) {
        var vm = this;

        vm.agentRequest = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.companies = Company.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentRequest.id !== null) {
                AgentRequest.update(vm.agentRequest, onSaveSuccess, onSaveError);
            } else {
                AgentRequest.save(vm.agentRequest, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentRequestUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.replyDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
